import {Component, EventEmitter, Output} from '@angular/core';
import {SimpleModalComponent} from 'ngx-simple-modal';
import {
  ExamSubjectCreateRequest,
  ExamSubjectsClient,
  ExamSubjectSelectListResponse,
  StudentsClient,
} from '../../../generated-client/generated-api-client';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {ErrorProcessorService} from 'src/app/services/error-processor.service';

export interface AddExamSubjectModal {
  studentIdParam?: string;
}

@Component({
  selector: 'app-add-exam-subject-modal',
  templateUrl: './add-exam-subject-modal.component.html',
  styleUrls: ['./add-exam-subject-modal.component.sass'],
})
export class AddExamSubjectModalComponent
  extends SimpleModalComponent<AddExamSubjectModal, boolean>
  implements AddExamSubjectModal
{
  addExamSubjectform!: FormGroup;
  isLoading: boolean = true;
  isInProgress: boolean = false;
  selectList!: ExamSubjectSelectListResponse;
  studentIdParam!: string;

  @Output() onConfirm: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private examSubjectClient: ExamSubjectsClient,
    private studentClient: StudentsClient,
    private toastr: ToastrService,
    private errorProcessorService: ErrorProcessorService
  ) {
    super();
  }

  ngOnInit(): void {
    this.examSubjectClient.getAvailableExamSubjects(this.studentIdParam).subscribe(
      response => {
        this.selectList = response;
        this.studentClient.nextExamDate(this.studentIdParam).subscribe(
          response2 => {
            this.addExamSubjectform = new FormGroup({
              studentId: new FormControl(this.studentIdParam),
              examSubject: new FormControl(null, [Validators.required]),
              grossTimeLimitMinutes: new FormControl(null, [Validators.required, Validators.min(0)]),
              timeLimitMultiplier: new FormControl(null, [Validators.min(0)]),
              startDateAtUtc: new FormControl(response2, [Validators.required]),
            });
            this.isLoading = false;

            this.errorProcessorService.formGroup = this.addExamSubjectform;
          },
          error => this.errorProcessorService.processError(error)
        );
      },
      error => this.errorProcessorService.processError(error)
    );
  }

  confirm() {
    this.isInProgress = true;
    const request: ExamSubjectCreateRequest = {
      studentId: this.studentId?.value,
      examSubjectSzevNexiusId: this.examSubject?.value,
      timeLimitMultiplier: this.timeLimitMultiplier?.value,
      startDateAtUtc: this.startDateAtUtc?.value,
      grossTimeLimitMinutes: this.grossTimeLimitMinutes?.value,
    };
    this.examSubjectClient.create(request).subscribe(
      response => {
        this.result = true;
        this.onConfirm.emit(this.result);
        this.isInProgress = false;
        this.close();
        this.toastr.success('Vizsgatárgy hozzáadása sikeres!');
      },
      error => {
        this.isInProgress = false;
        this.errorProcessorService.processError(error, true);
      }
    );
  }

  onExamSubjectChange() {
    if (this.examSubject?.value) {
      this.grossTimeLimitMinutes.setValue(this.selectList.items?.find(x => x.value === this.examSubject?.value)?.defaultGrossTimeLimitMinutes);
    }
  }

  get studentId() {
    return this.addExamSubjectform?.get('studentId');
  }

  get examSubject() {
    return this.addExamSubjectform?.get('examSubject')!;
  }

  get grossTimeLimitMinutes() {
    return this.addExamSubjectform?.get('grossTimeLimitMinutes')!;
  }

  get timeLimitMultiplier() {
    return this.addExamSubjectform?.get('timeLimitMultiplier')!;
  }

  get startDateAtUtc() {
    return this.addExamSubjectform?.get('startDateAtUtc')!;
  }
}
